// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collapsible-header {\n  background-color: #FFF;\n  color: #000;\n  font-size: 16px;\n  font-weight: 600\n}\n", ""]);
// Exports
module.exports = exports;
